import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ServiceService } from '../../../providers/service.service';
import { BaseComponent } from '../../shared/base/base.component';

@Component({
  selector: 'app-service-chooser',
  templateUrl: './service-chooser.component.html',
  styleUrls: ['./service-chooser.component.scss']
})
export class ServiceChooserComponent extends BaseComponent implements OnInit {

  @Input() service_type: string;
  @Input() vendor: string;
  @Input() person_type: string;
  @Output() choosed = new EventEmitter();
  services: any = [];

  constructor(
    public serviceService: ServiceService,
    public translator: TranslateService,
    public cookieService: CookieService,
    public titleService: Title,
  ) {
    super(serviceService, translator, cookieService, titleService);
  }

  service_length_shared = [
    { value: 1, name: '1MONTH' },
    { value: 3, name: '3MONTH' },
    { value: 6, name: '6MONTH' },
    { value: 12, name: '1YEAR' },
  ];

  async ngOnInit() {
    this.serviceService.getServicesByServiceType(this.service_type, this.vendor, this.person_type).subscribe((result1: any) => {
      result1.forEach(element => {
        let service_group = this.services.find(obj => obj.group_name === element.service_group);
        if (!service_group) {
          service_group = {
            group_name: element.service_group,
            services: [element]
          };
          this.services.push(service_group);
        } else {
          service_group.services.push(element);
        }

      });

      this.services.forEach(group_service => {
        group_service.services.forEach(service => {

          service.hasPenalty = service.rules.some(i => i.external_penalty > 0);
          service.hasDownDisc = service.rules.some(i => i.download_discount > 0);
          service.hasUpDisc = service.rules.some(i => i.upload_discount > 0);
          service.hasIntDisc = service.rules.some(i => i.internal_discount > 0);
          service.hasSocDisc = service.rules.some(i => i.social_discount > 0);

          // this.serviceService.getServiceRules(service.service_name).subscribe((result: any) => {
          //   service.rules = result.json();
          // });
          // this.serviceService.getServicePrices(service.service_name, this.id).subscribe((result: any) => {
          //   service.prices = result.json();
          // });
        });
      });
    }, error => {
      console.error(error);
    });
  }

  priceChoosed(price) {
    this.choosed.emit(price);
  }

}
